import cn from 'classnames';
// import { useContext, useEffect } from "react";
// import useReduxState from "@hooks/useReduxState";
// import { useQuery } from "@apollo/client";
// import type { Socket } from "socket.io-client";
// import { SocketContext } from "@context/socket";
// import { toastErrorMessage } from "@utils/utils";

import { ReactComponent as WhatIsDuelanaSvg } from '@assets/svg/what-is-duelana.svg';
import { ReactComponent as HowToPlaySvg } from '@assets/svg/how-to-play.svg';
import { ReactComponent as UpdatesSvg } from '@assets/svg/updates.svg';

import Layout from '@components/layout';
import { AccordionItem } from '@components/Accordion';
import styles from './HelpCenter.module.scss';
import { useState } from 'react';

export default function HelpCenter(): JSX.Element {
  //   const socket: Socket = useContext(SocketContext);
  const [activeCard, setActiveCard] = useState(0);

  const handleCardClick = (cardIndex: number) => {
    setActiveCard(cardIndex);
  };

  return (
    <Layout title='Help Center'>
      <div className={styles.container}>
        <h1>How can we help you?</h1>

        <div className={styles.cards}>
          <div
            className={cn(styles.card, { [styles.active]: activeCard == 0 })}
            onClick={() => {
              handleCardClick(0);
            }}
          >
            <div className={styles.icon}>
              <WhatIsDuelanaSvg />
            </div>
            <div className={styles.heading}>What is Duelana</div>
            <div className={styles.subline}>Learn more about Duelana</div>
          </div>

          <div
            className={cn(styles.card, { [styles.active]: activeCard == 1 })}
            onClick={() => {
              handleCardClick(1);
            }}
          >
            <div className={styles.icon}>
              <HowToPlaySvg />
            </div>
            <div className={styles.heading}>How to play</div>
            <div className={styles.subline}>Coming soon</div>
          </div>

          <div
            className={cn(styles.card, { [styles.active]: activeCard == 2 })}
            onClick={() => {
              handleCardClick(2);
            }}
          >
            <div className={styles.icon}>
              <UpdatesSvg />
            </div>
            <div className={styles.heading}>Updates</div>
            <div className={styles.subline}>Coming soon</div>
          </div>
        </div>

        <div className={styles.accordion}>
          <AccordionItem heading='What is Duelana?' withCaret>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor rhoncus dolor purus non enim
          </AccordionItem>

          <AccordionItem heading='How many games will be on your website ?' withCaret>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor rhoncus dolor purus non enim
          </AccordionItem>

          <AccordionItem heading='When do you launch $DUEL ?' withCaret>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor rhoncus dolor purus non enim
          </AccordionItem>
        </div>
      </div>
    </Layout>
  );
}
